import React from "react";
import { motion } from "framer-motion";
import { Clock } from "lucide-react";
import { content } from "../lib/i18n";
import { useLang } from "../context/LanguageContext";

const Hours = () => {
  const { lang } = useLang();
  const fr = content.hours.fr;
  const en = content.hours.en;
  const data = lang === "en" ? en : fr;

  return (
    <section id="hours" data-testid="hours-section" className="bg-white section">
      <div className="mx-auto max-w-[1320px] px-5 md:px-8 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
          <motion.div
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.55, ease: "easeOut" }}
            className="lg:col-span-5"
          >
            <span className="eyebrow-yellow">
              <Clock size={12} strokeWidth={2.5} />
              <span>{data.eyebrow}</span>
            </span>

            <h2
              data-testid="hours-title"
              className="mt-5 h-display text-[36px] sm:text-[44px] md:text-[60px] leading-[0.95]"
            >
              {data.title}
            </h2>

            <p className="mt-6 text-sm md:text-base text-black/70 max-w-sm leading-relaxed">
              {lang === "en"
                ? "Open every day. Service runs continuously through lunch and dinner."
                : "Ouvert tous les jours. Service en continu, midi et soir."}
            </p>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-60px" }}
            transition={{ duration: 0.55, ease: "easeOut", delay: 0.1 }}
            className="lg:col-span-7"
            data-testid="hours-table"
          >
            <ul className="bb-card overflow-hidden">
              {data.lines.map((line, i) => (
                <li
                  key={i}
                  data-testid={`hours-line-${i}`}
                  className={`flex items-center justify-between gap-4 px-6 md:px-8 py-5 md:py-6 ${
                    i !== data.lines.length - 1 ? "border-b-2 border-black/10" : ""
                  }`}
                >
                  <div className="flex items-center gap-3">
                    <span className="h-2 w-2 rounded-full bg-[var(--bb-yellow)]" />
                    <span className="font-display text-lg md:text-2xl uppercase">
                      {line.d}
                    </span>
                  </div>
                  <span className="font-display text-base md:text-xl uppercase tracking-wide text-black">
                    {line.h}
                  </span>
                </li>
              ))}
              <li className="flex items-center gap-3 px-6 md:px-8 py-4 bg-[var(--bb-yellow)]">
                <span className="h-2 w-2 rounded-full bg-black" />
                <span className="font-display text-sm md:text-base uppercase tracking-wide text-black">
                  {lang === "en" ? "Open 7 / 7" : "Ouvert 7 j / 7"}
                </span>
              </li>
            </ul>
          </motion.div>
        </div>
      </div>
    </section>
  );
};

export default Hours;
